module.exports = __webpack_public_path__ + "bdaf37f920eb89f19bf840be77b1f359.svg";